<template>
  <broker-side-menu />
  <div class="wrapper d-flex flex-column min-vh-100 bg-body">
    <broker-header :title="pageTitle" :group="pageGroup" :account-name="accountName" @logout="doLogout" />
    <main v-show="!pageLoadingStatus" class="container-fluid py-3">
      <router-view />
    </main>
  </div>
</template>

<script>
import BrokerHeader from '@/views/organisms/BrokerHeader'
import BrokerSideMenu from '@/views/organisms/BrokerSideMenu'

export default {
  name: 'DefaultLayout',
  components: {
    BrokerSideMenu,
    BrokerHeader,
  },
  computed: {
    pageTitle() {
      return this.$store.state.pageTitle ?? '';
    },
    pageGroup() {
      return this.$store.state.pageGroup ?? '';
    },
    accountName() {
      return this.$store.state.account.name ?? '';
    },
    pageLoadingStatus() {
      return this.$store.state.pageLoading;
    },
  },
  methods: {
    doLogout() {
      this.$store.dispatch('account/logout').then(() => {
        const managementCompanyCode = localStorage.getItem('managementCompanyCode');
        if (managementCompanyCode) {
          this.$router.push({name: 'Login', query: {mccd: managementCompanyCode}});
        } else {
          this.$router.push({name: 'Login'});
        }
      }).catch(() => this.$root.failApi());
    }
  },
}
</script>
